var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlassImageNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944,384H928a64,64,0,0,0-64-64H608a64,64,0,0,0-64,64H480a64,64,0,0,0-64-64H160a64,64,0,0,0-64,64H80a16,16,0,0,0-16,16v64a16,16,0,0,0,16,16H96v32A191.84,191.84,0,0,0,288,704c106,0,192-86,192-192V480l9.37-9.37a32,32,0,0,1,45.26,0L544,480v32A191.8,191.8,0,0,0,736,704c106,0,192-86,192-192V480h16a16,16,0,0,0,16-16V400A16,16,0,0,0,944,384ZM160,512V384H272L192.18,596.86A127,127,0,0,1,160,512Zm256,0A128.16,128.16,0,0,1,243,631.91L336,384h80Zm192,0V384H720L640.18,596.86A127,127,0,0,1,608,512Zm256,0A128.15,128.15,0,0,1,690.72,631.79L783.64,384H864Z",
    style: {
      fill: "#5b6673"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796,741.6l110.9,43.8a8,8,0,0,1,4.5,10.4,7.69,7.69,0,0,1-4.5,4.5L796,844,752.2,954.9a8,8,0,0,1-10.4,4.5,7.69,7.69,0,0,1-4.5-4.5L693.6,844,582.7,800.2a8,8,0,0,1-4.5-10.4,7.69,7.69,0,0,1,4.5-4.5l110.9-43.8,43.8-110.9a8,8,0,0,1,10.4-4.5,7.69,7.69,0,0,1,4.5,4.5Z",
    style: {
      fill: "#8a95a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.4,142l72.9,28.8a8,8,0,0,1,4.5,10.4,7.69,7.69,0,0,1-4.5,4.5l-72.9,28.8-28.8,72.9a8,8,0,0,1-10.4,4.5,7.69,7.69,0,0,1-4.5-4.5l-28.7-73-72.9-28.8a8,8,0,0,1-4.5-10.4,7.69,7.69,0,0,1,4.5-4.5L734,142l28.8-72.9a8,8,0,0,1,10.4-4.5,7.69,7.69,0,0,1,4.5,4.5Z",
    style: {
      fill: "#8a95a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.4,361.6l72.9,28.8a8,8,0,0,1,4.5,10.4,7.69,7.69,0,0,1-4.5,4.5L262.4,434l-28.8,72.9a8,8,0,0,1-10.4,4.5,7.69,7.69,0,0,1-4.5-4.5L190,434l-72.9-28.8a8,8,0,0,1-4.5-10.4,7.69,7.69,0,0,1,4.5-4.5L190,361.5l28.8-72.9a8,8,0,0,1,10.4-4.5,7.69,7.69,0,0,1,4.5,4.5Z",
    style: {
      fill: "#8a95a3"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassImageNormal);
export default __webpack_public_path__ + "static/media/glass_image_normal.e40793523385e2125b2cdb0052d97dfb.svg";
export { ForwardRef as ReactComponent };